import s from './DaySeparator.module.css'

/**
 * Пилюля-разделитель дня (`TimelineItem` типа `day`): «1 июля», «сегодня · 3 июля».
 *
 * Подпись приходит с сервера готовой (`label`) — фронт даты не форматирует и не склоняет.
 */
export function DaySeparator({ label }: { label: string }) {
  return (
    <div className={s.root}>
      <span className={s.pill}>{label}</span>
    </div>
  )
}
